(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeDialogController', CustomRouteTypeAttributeDialogController);

    CustomRouteTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomRouteTypeAttribute'];

    function CustomRouteTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomRouteTypeAttribute) {
        var vm = this;

        vm.customRouteTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customroutetypeattributevalues = CustomRouteTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customRouteTypeAttribute.customRouteTypeAttributeValues != null && vm.customRouteTypeAttribute.customRouteTypeAttributeValues.length != 0) {
			vm.items = vm.customRouteTypeAttribute.customRouteTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customRouteTypeAttribute.id !== null) {
            	
            	 vm.customRouteTypeAttribute.customRouteTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRouteTypeAttribute.customRouteTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomRouteTypeAttribute.update(vm.customRouteTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customRouteTypeAttribute.customRouteTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRouteTypeAttribute.customRouteTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomRouteTypeAttribute.save(vm.customRouteTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customRouteTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-route-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
